export class DiagnosticReportModel {
  id: string;
  scenarioId: string;
  scenarioType: string;
  countryCode: string;
  workflowTemplateId: string;
  workflowExecutionId: string;
  isDescriptionHidden: boolean;
  countryCodes: Array<string> = new Array<string>();
}

export class DiagnosticReportWorksheetModelDto {
  id: string;
  diagnosticReportId: string;
  scenarioId: string;
  scenarioType: string;
  countryCode: string;
  worksheetName: string;
  worksheetId: string;
  fieldCount: number;
  diagnosticReportFieldModelsDto: Array<DiagnosticReportFieldModelDto> = new Array<DiagnosticReportFieldModelDto>();
}


export class DiagnosticReportFieldModelDto {
  id: string;
  columnIndex: number;
  rowIndex: number;
  mismatchedRecordCount: number;
  title: string;
  countryName: string;
  countryCode: string;
  mismatchedRecordSummaries: Array<DiagnosticReportMismatchedRecordSummaryModel> = new Array<DiagnosticReportMismatchedRecordSummaryModel>();
}

export class DiagnosticReportMismatchedRecordSummaryModel {
  id: string;
  displayText: string;
  counterPartsCount: number;
  columnIndex: number;
  rowIndex: number;
  fieldModelId: string;
  fieldName: string;
  comment: string;
  cellValue: any;
}

export class DiagnosticsReportRecordInfo {
  fieldName: string;
  fieldValue: string;
}
export class DiagnosticReportMismatchedRecordDetailsModel {
  mismatchedDetails: DiagnosticReportMismatchedRecordModel;
  recordDetails: Array<DiagnosticsReportRecordInfo> = new Array<DiagnosticsReportRecordInfo>();
}

export class DiagnosticReportMismatchedRecordModel {
  id: string;
  diagnosticReportWorksheetId: string;
  fieldModelId: string;
  columnIndex: number;
  rowIndex: number;
  value: any;
  countryName: string;
  countryCode: string;
  displayText: string;
  fieldName: string;
  type: string;
  counterParts: Array<DiagnosticReportMismatchedRecordCounterPartModel> = new Array<DiagnosticReportMismatchedRecordCounterPartModel>();
}

export class DiagnosticReportMismatchedRecordCounterPartModel {
  countryCode: string;
  countryName: string;
  fieldValues: any = {};
  value: any;
  type: string;
}

export class CountryCalculatorDto {
  name: string;
  status: string;
  code: string;
}

export class DiagnosticReportSelectedRecordInfo {
  worksheetName: string;
  columnIndex: number;
  rowIndex: number;
  selectedReportId: string;
  fieldModelId: string;
}
